import React, { Component } from 'react'
import '../styles/Financing.css'
import DropdownWidget from '../widgets/DropdownWidget'
import deleteIcon from '../images/trash_green.png'
import addIcon from '../images/plus_green.png'
import deleteIconGray from '../images/trash_gray.png'
import addIconGray from '../images/plus_gray.png'
import APIFarmerRequest from '../api/APIFarmerRequest'
import AlertMessage from '../widgets/AlertMessage'

class Financing extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemObj: {},
			keyTracer: 0,
			listItems: [],
			financing: {},
			addFinancing: {},
			deleteFinancing: {}
		}
		this.eventHandler = this.eventHandler.bind(this)
		this.setAllFieldsDisabled = this.setAllFieldsDisabled.bind(this)
		this.getAllFinancing = this.getAllFinancing.bind(this)
		this.getFarmerDetailsById = this.getFarmerDetailsById.bind(this)
	}

	componentWillMount() {
		this.getAllFinancing()
	}

	getAllFinancing() {
		const instrument = APIFarmerRequest.getAllFinancing(this.state.accessToken)
		instrument.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const c = []
			for(const v of response.results.rows) {
				c.push({id: v.financing_id, name: v.name})
			}
			if(this.props.farmerID != null) {
				this.getFarmerDetailsById(c)
			}
			else {
				const listItems = []
				const k = "li-" + this.state.keyTracer
				this.state.itemObj[k] = <ListItem finance={c} view={this.props.view}
					handler={this.eventHandler} key={k} id={k} />
				this.state.keyTracer++
				listItems.push(this.state.itemObj[k])
				this.setAllFieldsDisabled(false)
				this.setState({finance: c, listItems: listItems})
			}
		})
	}

	getFarmerDetailsById(finance) {
		const farmer = APIFarmerRequest.getFarmerDetailsById(this.state.accessToken,
			parseInt(this.props.farmerID))
		farmer.then((response) => {
			if(response.status === "FAILED") {
				return
			}
			const listItems = []
			for(const v of response.results.financing) {
				const k = "li-" + this.state.keyTracer
				this.state.keyTracer++
				const pcl = <ListItem finance={finance} data={v} view={this.props.view}
					handler={this.eventHandler} key={k} id={k} />
				listItems.push(pcl)
				this.state.itemObj[k] = pcl
			}
			if(this.props.view === "update" || this.props.view === "view-details" ) {
				const k = "li-" + this.state.keyTracer
				this.state.keyTracer++
				const pcl = <ListItem finance={finance} view={this.props.view}
					handler={this.eventHandler} key={k} id={k} />
				listItems.push(pcl)
				this.state.itemObj[k] = pcl
			}
			this.setState({finance: finance, listItems: listItems})
			if(this.props.view === "view-details") {
				this.setAllFieldsDisabled(true)
			}
			else {
				this.setAllFieldsDisabled(false)
			}
		})
	}

	setAllFieldsDisabled(v) {
		const fields = document.querySelectorAll('.financing *')
		for(const f of fields) {
			f.disabled = v
		}
	}

	eventHandler(e, compId, key, value) {
		switch(e) {
			case "financing":
					this.state.financing[compId] = value
					if(this.props.view === "update") {
						if(this.state.financing[compId]["id"] != undefined) {
							this.props.onValueChange("financing", "financing", "financing", this.state.financing)
						}
					} else {
						this.props.onValueChange("financing", "financing", "financing", this.state.financing)
					}
				break
			case "add":
					if(value != null && this.props.view === "update") {
						this.state.addFinancing[compId] = value
						this.props.onValueChange("financing", "financing", "add", this.state.addFinancing)
					}
					const added = []
					const k = "li-" + this.state.keyTracer
					this.state.itemObj[k] = <ListItem finance={this.state.finance} 
						view={this.props.view} handler={this.eventHandler} key={k} id={k} />
					this.state.keyTracer++
					Object.keys(this.state.itemObj).forEach((k => {
						added.push(this.state.itemObj[k])
					}))
					this.setState({listItems: added})

				break
			case "delete":
					if(value != null && this.props.view === "update") {
						this.state.deleteFinancing[compId] = value
						this.props.onValueChange("financing", "financing", "delete", this.state.deleteFinancing)
						delete this.state.addFinancing[compId]
						this.props.onValueChange("financing", "financing", "add", this.state.addFinancing)
					}
					if(this.state.listItems.length === 1) {
						break
					}
					delete this.state.itemObj[compId]
					delete this.state.financing[compId]
					this.props.onValueChange("financing", "financing", "financing", this.state.financing)
					const deleted = []
					Object.keys(this.state.itemObj).forEach((k => {
						deleted.push(this.state.itemObj[k])
					}))
					this.setState({listItems: deleted})
				break
		}
	}

	render() {
		const view = <div className="financing">
			<table className="f-table-header">
				<col style={{width: '50%'}} />
				<col style={{width: '50%'}} />
				<tr>
					<th>* Type of Financial Source</th>
					<th>Name of Financial Source</th>
				</tr>
			</table>
			{this.state.listItems}

		</div>
		return(view)
	}
}

class ListItem extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			itemId: props.id,
			finance: props.finance,
			source: "-- SELECT --",
			handler: props.handler,
			financing: {},
		}
		this.onAddItemClick = this.onAddItemClick.bind(this)
		this.onDeleteItem = this.onDeleteItem.bind(this)
	}

	componentDidMount() {
		if(this.props.data != null) {
			this.state.financing["id"] = this.props.data.id
			const instrument = APIFarmerRequest.getFinancingById(this.state.accessToken,
				this.props.data.financing_id)
			instrument.then((response) => {
				this.setState({source: response.results.name})
			})
			this.setState({
				addDeleteButton: (this.props.view === 'update')? <img src={deleteIcon} 
					className="delete-icn" alt="DELETE" onClick={this.onDeleteItem}/>:
					<img src={deleteIconGray} className="delete-icn" alt="DELETE"/>,
				name: this.props.data.name
			})
		}
		else {
			this.setState({addDeleteButton: (this.props.view === 'view-details')?
				<img src={addIconGray} className="add-icon" alt="ADD"/>:
				<img src={addIcon} className="add-icon" alt="ADD" onClick={this.onAddItemClick} key="add"/>})
		}

	}

	onAddItemClick() {
		this.state.handler("add", this.state.itemId, null, this.state.financing)
		this.setState({addDeleteButton: <img src={deleteIcon} className="delete-icon" 
			alt="DELETE" onClick={this.onDeleteItem} />})
	}

	onDeleteItem() {
		// this.state.handler("delete", this.state.itemId, null, this.state.financing)
		const name = this.state.financing["name"]? this.state.financing["name"]: this.state.name
		this.setState({
			showConfirmMessage: true,
			aMessage: `Are you sure you want to remove financial source ${name}?`
		})
	}

	render() {
		const view = <div className="f-list-item">
			<div>{this.state.addDeleteButton}</div>
			<table className="f-table-data">
				<col style={{width: '50%'}} />
				<col style={{width: '50%'}} />
				<tr>
					<td><DropdownWidget list={this.state.finance} placeholder={this.state.source}
						cStyle={{"width": "calc(100% - 5px)"}} onItemSelected={(id, val) => {
							this.state.financing["financing_id"] = id
							this.props.handler("financing", this.state.itemId, null, this.state.financing)
							if(this.state.addDeleteButton.props.alt == "ADD") {
								this.onAddItemClick()
							}
						}} /></td>
					<td><input type="text" value={this.state.name} onChange={(e) => {
						this.state.financing["name"] = e.target.value
						this.props.handler("financing", this.state.itemId, null, this.state.financing)
						if(this.state.addDeleteButton.props.alt == "ADD") {
							this.onAddItemClick()
						}
						this.setState({name: e.target.value})
					}} /></td>
				</tr>
			</table>
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					this.state.handler("delete", this.state.itemId, null, this.state.financing)
				}
			}} />}
		</div>
		return(view)
	}
}

export default Financing
